import React from 'react';
import { Theme, withStyles } from '@material-ui/core';
import { NOTIFICATION_SEMIBOLD_CLASS } from '../../registerNotificationFonts';
import type { ToBeReviewedItem } from '../../types';

type RouteMaxTheme = Theme & {
  textFontSize?: number;
  TextColor?: string;
};

type PickupReviewBodyProps = {
  classes: Record<string, string>;
  item: ToBeReviewedItem;
};

const PickupReviewBody = ({ classes, item }: PickupReviewBodyProps) => (
  <div className={classes.content}>
    {item.driverDisplay ? (
      <div className={`${classes.driver} ${NOTIFICATION_SEMIBOLD_CLASS}`}>
        {item.driverDisplay}
      </div>
    ) : null}
    {item.shipperName ? (
      <div className={classes.shipper}>{item.shipperName}</div>
    ) : null}
  </div>
);

const styles = (theme: Theme) => {
  const routeMaxTheme = theme as RouteMaxTheme;

  return {
    content: {
      display: 'flex',
      flexDirection: 'column',
    },
    driver: {
      fontSize: routeMaxTheme.textFontSize,
      color: routeMaxTheme.TextColor,
      lineHeight: '18px',
      textTransform: 'uppercase',
      marginBottom: 4,
    },
    shipper: {
      fontSize: routeMaxTheme.textFontSize,
      color: routeMaxTheme.TextColor,
      lineHeight: '18px',
      textTransform: 'uppercase',
      opacity: 0.85,
    },
  };
};

export default withStyles(styles as Parameters<typeof withStyles>[0])(PickupReviewBody);
